import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-conditions-modal',
  templateUrl: './terms-conditions-modal.component.html',
  styleUrls: ['./terms-conditions-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TermsConditionsModalComponent implements OnInit {
  @ViewChild('scrollableContent', { static: false }) scrollableContent!: ElementRef;
  
  hasScrolledToBottom: boolean = false;
  acceptButtonText: string = 'Accept';
  cancelButtonText: string = 'Cancel';
  useLicenseItems: string[] = [];

  constructor(
    public activeModal: NgbActiveModal, 
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    // Load translations
    this.translate.get('auth_accept').subscribe((translation: string) => {
      this.acceptButtonText = translation !== 'auth_accept' ? translation : 'Accept';
    });
    
    this.translate.get('auth_cancel').subscribe((translation: string) => {
      this.cancelButtonText = translation !== 'auth_cancel' ? translation : 'Cancel';
    });

    this.translate.get([
      'terms.use_license_item1',
      'terms.use_license_item2',
      'terms.use_license_item3',
      'terms.use_license_item4'
    ]).subscribe((res: any) => {
      this.useLicenseItems = [
        res['terms.use_license_item1'],
        res['terms.use_license_item2'],
        res['terms.use_license_item3'],
        res['terms.use_license_item4']
      ].filter(Boolean);
    });
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    
    // Check if user has scrolled to the bottom (with small tolerance)
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      this.hasScrolledToBottom = true;
    }
  }

  onAccept(): void {
    if (this.hasScrolledToBottom) {
      this.activeModal.close(true);
    }
  }

  onCancel(): void {
    this.activeModal.dismiss(false);
  }
}
